import { TextField } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

const NumberField = (props) => {
  const {
    control,
    name,
    rules = {},
    defaultValue,
    digits,
    InputProps,
    errorText,
    disabled = false,
    allowNegative=false,
    min,
    max,
    decimalPlaces,
    preserveLeadingZeros = false,
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={{
        ...rules,
      }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          disabled={disabled}
          type="number"
          value={
            typeof field.value === "string" && !preserveLeadingZeros
              ? field.value.replace(/^0+/, "")
              : field.value
          }
          onChange={(event) => {
            let value = event.target.value;
            if (digits) {
              value = value.slice(0, digits);
            }
            // if (decimalPlaces !== undefined) {
            //   const decimalIndex = value.indexOf(".");
            //   if (decimalIndex !== -1) {
            //     const decimalPart = value.slice(decimalIndex + 1);
            //     if (decimalPart.length > decimalPlaces) {
            //       value = value.slice(0, decimalIndex + decimalPlaces + 1);
            //     }
            //   }
            // }
            if (!allowNegative && value.startsWith("-")) {
              value = value.slice(1);
            }
            if (min !== undefined && value < min) {
              value = min.toString();
            }
            if (max !== undefined && value > max) {
              value = max.toString();
            }
            if (value === "") {
              if (defaultValue) {
                field.onChange(defaultValue);
              } else {
                field.onChange(value);
              }
            } else {
              field.onChange(value);
            }
          }}
          error={!!error}
          helperText={errorText && error ? error.message : null}
          fullWidth
          size="small"
          InputProps={{
            // style: { fontSize: '0.75rem' }
            ...InputProps,
          }}
        />
      )}
    />
  );
};

export default NumberField;
